import { ErrorPageBase, ErrorPageBaseProps } from 'noddi-ui-web';
import { LogInput } from 'noddi-util';
import { useEffect } from 'react';
import { log } from '../../utils/logUtil';

export const ErrorPage = ({
  title,
  description,
  buttonProps,
  logInput
}: ErrorPageBaseProps & {
  logInput?: LogInput;
}) => {
  const { value, severity, cause, extra } = logInput ?? {};
  useEffect(() => {
    if (severity && value !== undefined) {
      log({ value, severity, cause, extra });
    }
  }, [value, severity, cause, extra]);
  return <ErrorPageBase title={title} description={description} buttonProps={buttonProps} />;
};
